import React from 'react';
import LoadingSpinner from '../loadingSpinner/LoadingSpinner';

type SuspenseLoaderProps = {
  message?: string;
  fullHeight?: boolean;
  className?: string;
};

const SuspenseLoader: React.FC<SuspenseLoaderProps> = ({
  message = 'Loading...',
  fullHeight = false,
  className = ''
}) => {
  const containerClasses = [
    'flex items-center justify-center',
    fullHeight ? 'min-h-screen' : 'min-h-[200px]',
    className
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={containerClasses}>
      <div className="flex flex-col items-center justify-center space-y-4">
        <LoadingSpinner className="w-8 h-8" />
        <p className="text-base text-zinc-600">{message}</p>
      </div>
    </div>
  );
};

export default SuspenseLoader;
